// Marketing-site runtime config.
// All values must be safe for the public bundle — no secrets.

export const APP_URL: string =
  (import.meta.env.VITE_APP_URL as string | undefined) ?? 'https://app.edupra.com';

export const CONTACT_EMAIL: string =
  (import.meta.env.VITE_CONTACT_EMAIL as string | undefined) ?? 'hello@edupra.com';
